module.exports = __webpack_public_path__ + "static/img/xg3.747ea532.png";